
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.66 9.846h-.607v-5.46a1.011 1.011 0 00-1.011-1.01h-1.82V1.15A1.011 1.011 0 007.784.235L2.527 2.69a1.014 1.014 0 00-.584.917v6.24h-.607a.607.607 0 100 1.213H12.66a.607.607 0 100-1.213zM10.84 4.59v5.257H9.222V4.59h1.618zm-7.684-.855L8.009 1.47v8.376H3.156V3.734zM7.2 5.195v.607a.607.607 0 01-1.213 0v-.607a.607.607 0 011.213 0zm-2.022 0v.607a.607.607 0 01-1.213 0v-.607a.607.607 0 011.213 0zm0 2.63v.606a.607.607 0 11-1.213 0v-.607a.607.607 0 011.213 0zm2.022 0v.606a.607.607 0 11-1.213 0v-.607a.607.607 0 011.213 0z"}})])
          )
        }
      }
    